module.exports = __webpack_public_path__ + "static/img/faq.18f7f17b.png";